






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Tutorial from '@/components/tools/Tutorial.vue';
import Verifier from '@/components/tools/Verifier.vue';
import Buttons from '@/components/tools/Buttons.vue';
import Towers from '@/components/towers/Towers.vue';
import Kiosks from '@/components/kiosks/Kiosks.vue';
import Bridges from '@/components/bridges/Bridges.vue';
import Weights from '@/components/weights/Weights.vue';
import WeightCheck from '@/components/weights/WeightCheck.vue';

@Component({
  components: {
    Tutorial,
    Verifier,
    Buttons,
    Towers,
    Kiosks,
    Bridges,
    Weights,
    WeightCheck,
  },
})

export default class Game extends Vue {
  @Prop({ required: true })
  type!: string;

  @Prop({ required: true })
  level!: number;

  @Prop({ required: true })
  language!: string;

  // eslint-disable-next-line global-require, import/no-dynamic-require
  text = require(`@/text_${this.language}.json`);

  correctSolution = false;

  showSolution = false;

  showTutorial = false;

  tip = 'Guter Versuch! Probiere es noch einmal!';

  get currentGameComponent(): string {
    return this.type;
  }

  showTip(msg: string):void {
    this.correctSolution = false;
    this.tip = msg;
  }
}
